import Vue from 'vue';
import VueRouter from 'vue-router';
import { Auth, Hub } from 'aws-amplify';
import Store from '../store/index';
import Home from '../views/Home.vue';
import Login from '../views/Login.vue';

Vue.use(VueRouter);

let user;

// Define routes
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
  {
    path: '/application',
    name: 'Application',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "application" */ '../views/Application.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/contact',
    name: 'Contact Us',
    // route level code-splitting
    // this generates a separate chunk (contact.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "contact" */ '../views/Contact.vue'),
  },
  {
    path: '/loans',
    name: 'Small Business Funding',
    // route level code-splitting
    // this generates a separate chunk (contact.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "loans" */ '../views/Loans.vue'),
  },
  {
    path: '/investors',
    name: 'Reach Investors',
    // route level code-splitting
    // this generates a separate chunk (contact.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "investors" */ '../views/Investors.vue'),
  },
];

const router = new VueRouter({
  routes,
});

// Get user from Cognito
function getUser() {
  return Auth.currentAuthenticatedUser().then((cognitoUser) => {
    if (cognitoUser && cognitoUser.signInUserSession) {
      Store.dispatch('setUser', cognitoUser);
      Store.dispatch('setAuthState', 'signedIn');
      return cognitoUser;
    }
    return false;
  }).catch((error) => {
    Store.dispatch('resetAuthStates');
    // TODO: do something with error
    if (error) {
      // Do nothing
    }
    return null;
  });
}

getUser().then((cognitoUser, error) => {
  if (cognitoUser) {
    router.push({ path: '/' });
  }
  if (error) {
    // TODO: do something with error
    if (error) {
      // Do nothing
    }
  }
});

// Handle auth check
router.beforeResolve(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    user = await getUser();
    if (!user) {
      return next({
        path: '/login',
        query: {
          redirect: to.fullPath,
        },
      });
    }
    return next();
  }
  return next();
});

// Implement auth event listeners
Hub.listen('auth', (data) => {
  const { payload } = data;
  // Set AuthState event values
  if (payload.event === 'signIn') {
    Store.dispatch('setAuthState', 'signedIn');
    router.push(router.currentRoute.query.redirect || '/');
  }
  if (payload.event === 'signOut') {
    Store.dispatch('setAuthState', 'signedOut');
    router.push({ path: '/' });
  }
  if (payload.event === 'signIn_failure') {
    // Do nothing for now
  }
  // TODO: Log events from Hub
});

export default router;
